// extracted by mini-css-extract-plugin
export default {"participantMain":"Participant_participantMain--Qo3","participantName":"Participant_participantName--zIC","table":"Participant_table--isi"};